import React from 'react';
import 'whatwg-fetch';

import clerkWithTieIcon from 'src/images/icons/002-clerk-with-tie.svg';
import withAuth from 'src/hoc/withAuth';

const apiSearchBar = '/api/searchBar/';
const apiCustomerShow = '/api/customer/show/';

const oriState = {
  currQuery: '',
  dataCustomer: undefined,
  showList: true,
  customerSelectedId: undefined,
  researchClicked: false,
};

class ModalCustomerLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.refreshResults = this.refreshResults.bind(this);
    this.linkToHeadOffice = this.linkToHeadOffice.bind(this);
    this.close = this.close.bind(this);
    this.reset = this.reset.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
  }

  handleClick(param) {
    this.setState({
      currQuery: param.installationSite.socialReason,
      showList: false,
      customerSelectedId: param.id,
      researchClicked: true,
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleSubmit() {
    if (this.state.customerSelectedId === this.props.entityAssociated.id) {
      this.props.openToast(false, 'Impossible de lier le compte à lui même');
    } else {
      this.linkToHeadOffice(this.state.customerSelectedId, this.props.entityAssociated.id);
    }

    this.close();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.researchClicked && this.state.currQuery != '' && prevState.currQuery != this.state.currQuery) {
      this.refreshResults(this.state.currQuery);
      this.setState({
        showList: true,
      });
    }

    if (prevState.researchClicked === true) {
      this.setState({
        researchClicked: false,
      });
    }

    return true;
  }

  refreshResults(currQuery) {
    let queryURL = apiSearchBar;
    let graphQL =
      '{ customers(search: "' +
      currQuery +
      '" ){ id, installationSite{ socialReason } }, contacts(search: "' +
      currQuery +
      '" ){ id, name, lastname }, employees(search: "' +
      currQuery +
      '" ){ id, firstname, lastname, user{ id, username } } }';
    queryURL += encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            dataCustomer: data['data']['customers'],
          });
          //console.log(data);
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch search customers: \n' + error);
        }.bind(this)
      );
  }

  render() {
    if (this.props.isOpen === false) return null;

    const { dataCustomer } = this.state;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content modal-link'>
            <div className='modal-header'>
              <h4 className='modal-title'>Lier au compte principal</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              <input
                ref='searchInput'
                name='currQuery'
                value={this.state.currQuery}
                onChange={this.handleInputChange}
                type='text'
                className='form-control'
                placeholder='Recherche client'
              />
              {this.state.currQuery != '' && this.state.showList && (
                <ul id='listSearchResult'>
                  {!dataCustomer && <span>Chargement...</span>}
                  {dataCustomer && dataCustomer.length == 0 && <span>Aucun résultat</span>}

                  {dataCustomer ? ( // list the customer results
                    dataCustomer.map((data, i) => (
                      <li onClick={this.handleClick.bind(this, data)}>
                        <img className='imgSearchResult' src={clerkWithTieIcon} />
                        <span>{data.installationSite.socialReason}</span>
                      </li>
                    ))
                  ) : (
                    <span></span>
                  )}
                </ul>
              )}
            </div>
            <div className='modal-actions'>
              <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                Annuler
              </button>
              <button onClick={this.handleSubmit} type='button' className='btn-link modal-action' data-dismiss='modal'>
                <strong>Lier</strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  linkToHeadOffice(headOfficeId, subOfficeId) {
    const graphQL = 'mutation { customer(id:' + subOfficeId + ' headOfficeId:' + headOfficeId + '){headOffice{ id }}}';

    let queryURL = apiCustomerShow;
    let data = 'data=' + encodeURIComponent(graphQL);

    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['customer']['headOffice']['id'] == headOfficeId) {
            this.props.openToast(true, 'Le compte à bien été lié.');
            this.props.onLinkResult();
          } else {
            this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
          }
        }.bind(this)
      )
      .catch(
        function () {
          console.log('erreur fetch UPDATE customer entity');
        }.bind(this)
      );
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withAuth(ModalCustomerLink);
